// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/layouts/LoginLayout.tsx

import { Outlet } from "react-router-dom";

const LoginLayout = () => {
  return (
    <div className="min-h-screen w-full">
      <Outlet />
    </div>
  );
};

export default LoginLayout;